import styled, { css } from "styled-components";

type SectionContentProps = {
    collapse: boolean;
};

type InformationColorProps = {
  backgroundColor: string;
  borderColor: string;
}

export const TalhoesListContent = styled.div<SectionContentProps>`
  min-height: 0;
  display: flex;
  flex-direction: column;
  height: ${({ collapse }) => (collapse ? "100%" : 'auto')};
  flex: ${({ collapse }) => (collapse ? "0 0 50%" : 'none')};
  `;

export const TalhoesSection = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const MarkersContainer = styled.div`
  border: 2px solid black !important;
  pointer-events: auto;
  z-index: 1000000;

  & > .marker-text {
    margin-left: 10px;
  }
`;

export const SectionHeader = styled.div<SectionContentProps>`
  /* background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%); */
  border: 2px solid #e8eaf6;
  border-radius: 12px;
  padding: 0px 16px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

  background-color: ${({ collapse }) => (collapse ? "linear-gradient(135deg, #e8eaf6 0%, #c5cae9 100%)" : 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)')};
  border-color: ${({ collapse }) => (collapse ? "#009157" : 'none')};
  flex: 0 0 auto;

  &:hover {
    background: linear-gradient(135deg, #f8f9fa 0%, #e8eaf6 100%);
    border-color: #009157;
    box-shadow: 0 2px 8px rgba(63, 81, 181, 0.15);
    transform: translateY(-1px);
  }

  .icon-chevron {
    margin-left: auto;
    color: rgb(103, 108, 119) !important;
    transition: transform 0.3s ease;
    transform: ${(props) => (props.collapse ? "rotate(90deg)" : "rotate(0)")};
  }
`;

export const SectionTitle = styled.span`
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  color: rgb(103, 108, 119);
  letter-spacing: 0.01em;
`;

export const SectionCount = styled.span`
  background: #009157;
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  min-width: 24px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(63, 81, 181, 0.3);
`;

export const SectionContent = styled.div<SectionContentProps>`
  transition: all 0.3s ease;
  padding-left: 8px;
  overflow-y: auto;
  height: 100%;

  flex: 1;
  min-height: 0;
  overflow: auto;

${(props) =>
    props.collapse
      ? css`
          opacity: 1;
        `
      : css`
          max-height: 0;
          opacity: 0;
        `}
 
`;

export const TalhaoItemCompact = styled.div`
  background: #ffffff;
  border: 1px solid #e8eaf6;
  border-radius: 6px;
  padding: 6px 8px;
  margin-bottom: 4px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 28px;

  &:hover {
    border-color: #009157;
    background: #f8f9fa;
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(63, 81, 181, 0.1);
  }

  input {
    width: 14px;
    height: 14px;
    accent-color: #2196f3;
    margin: 0;
    cursor: pointer;
    flex-shrink: 0;
  }
`;

export const TalhaoInfoCompact = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  min-width: 0;
`;

export const TalhaoCodigoCompact = styled.span<{checked: boolean}>`
  font-weight: 600;
  color: ${(props) => (props.checked ? "#1a237e" : "rgb(103, 108, 119)")};
  font-size: 13px;
  flex-shrink: 0;
`;

export const TalhaoAreaCompact = styled.span<{checked: boolean}>`
  font-size: 11px;
  color: white;
  font-weight: 600;
  background-color: ${(props) => (props.checked ? "#009157" : "rgb(103, 108, 119)")};
  padding: 2px 6px;
  border-radius: 8px;
  min-width: 35px;
  text-align: center;
  flex-shrink: 0;
`;

export const MapContainer = styled.div`
  flex: 1;
  position: relative;
  background: #f5f5f5;
`;

export const CounterInformation = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 1000;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;

  > div:nth-child(1) {
    font-size: 18px;
    font-weight: 600;
    color: #757575;
  }
  
  > div:nth-child(2) {
    font-size: 12px;
    color: #666;
    text-align: center;
  }

  > div:nth-child(3) {
    font-size: 14px;
    font-weight: 500;
    color: #424242;
    margin-top: 4px;
  }
`;

export const ToogleList = styled.div`
  position: absolute;
  bottom: 16px;
  right: 66px;
  z-index: 1000;

  button {
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 12px;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #424242;
    transition: all 0.2s;
  }
`;

export const LegendInformation = styled.div`
  position: absolute;
  bottom: 40px;
  left: 16px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const LegendMap = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 12px;
  max-width: 300px;
`;

export const LegendMapTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #424242;
  margin-bottom: 8px;
`;

export const LegendMapContent = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const LegendMapItem = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
`;

export const InformationColor = styled.span<InformationColorProps>`
  width: 16px;
  height: 16px;
  background-color: ${({ backgroundColor }) => backgroundColor};
  border: 1px solid ${({ borderColor }) => borderColor};
  border-radius: 2px;
`;


export const MapContent = styled.div`
  width: 100%;
  height: 100%;
`;